(function() {
  if (window.__twrdNavWishlistInit) return;
  window.__twrdNavWishlistInit = true;

  var WISHLIST_KEY = 'twrd_wishlist';
  function getCount() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]').length; } catch(_) { return 0; }
  }

  /* The store's event carries the new count, not the direction. Keep the
     previous count here and compare, rather than changing the shared store. */
  var lastCount = null;
  var flagTimer = null;
  var popTimer = null;

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function flagFor(link) {
    var flag = link.querySelector('.twrd-nav-wishlist__flag');
    if (flag) return flag;
    flag = document.createElement('span');
    flag.className = 'twrd-nav-wishlist__flag';
    flag.setAttribute('aria-hidden', 'true');
    link.appendChild(flag);
    return flag;
  }

  /* Same move as the card heart, so the save reads as one action that ends up
     in the corner. The word says which way it went. */
  function signal(added, kind) {
    var links = document.querySelectorAll('[data-twrd-nav-wishlist]');
    clearTimeout(popTimer);
    clearTimeout(flagTimer);
    links.forEach(function(l) {
      l.removeAttribute('data-pop');
      var flag = flagFor(l);
      flag.textContent = added ? 'Saved' : 'Removed';
      flag.classList.remove('is-on');
    });
    /* Reflow so a second click restarts the animation. */
    if (links.length) void links[0].offsetWidth;
    links.forEach(function(l) {
      if (!reduced()) l.setAttribute('data-pop', kind || (added ? 'add' : 'remove'));
      l.querySelector('.twrd-nav-wishlist__flag').classList.add('is-on');
    });
    popTimer = setTimeout(function() {
      links.forEach(function(l) { l.removeAttribute('data-pop'); });
    }, kind === 'receive' ? 820 : (added ? 340 : 280));
    flagTimer = setTimeout(function() {
      links.forEach(function(l) {
        var flag = l.querySelector('.twrd-nav-wishlist__flag');
        if (flag) flag.classList.remove('is-on');
      });
    }, 1100);
  }

  /* A heart is flying up from the product page (twrd-product-actions). Hold
     the badge and the fill until it lands, then receive it. */
  var pending = false;
  document.addEventListener('twrd:heart-landed', function() {
    if (!pending) return;
    pending = false;
    updateBadge('receive');
  });

  function updateBadge(kind) {
    var badges = document.querySelectorAll('[data-twrd-wishlist-badge]');
    var links = document.querySelectorAll('[data-twrd-nav-wishlist]');
    if (!badges.length || !links.length) return;
    var count = getCount();
    if (kind !== 'receive' && window.__twrdHeartFlight && lastCount !== null && count > lastCount) {
      pending = true;
      return;
    }
    badges.forEach(function(b) {
      b.setAttribute('data-count', count);
      b.textContent = count > 99 ? '99+' : String(count);
    });
    links.forEach(function(l) {
      l.setAttribute('data-has-items', count > 0 ? 'true' : 'false');
    });
    if (lastCount !== null && count !== lastCount) signal(count > lastCount, kind === 'receive' ? 'receive' : null);
    lastCount = count;
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function() {
    updateBadge();
    function onChange() { updateBadge(); }
    document.addEventListener('twrd:wishlist-changed', onChange);
    document.addEventListener('twrd:wishlist:change', onChange);
    window.addEventListener('twrd:wishlist-changed', onChange);
    window.addEventListener('twrd:wishlist:change', onChange);
    window.addEventListener('storage', function(e) {
      if (e.key === WISHLIST_KEY) updateBadge();
    });
  });
})();
